import { arrayFieldSchema } from '@shared/schemas';

export const issueTypeSchema = arrayFieldSchema(
  'issueTypes',
  'Please select at least one option',
);
